import axios from 'axios';
import { API_BASE_URL, LAMBDA_BASE_URL } from '../../../../constants';
import { getDomainId } from '../../../../utils/utils';

const formatDate = (date) =>
  new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  })

const getAllDatesInRange = (startDate , endDate) => {
    const start = new Date(startDate)
    const end = new Date(endDate)
    const dates = []

    while (start <= end) {
        dates.push(new Date(start));
        start.setDate(start.getDate() +1)
    }
    return dates;
}


const GradientLineChartData3 = async (start , end) => {
    try {
        const domainId = await getDomainId();
        const res = await axios.get(`${LAMBDA_BASE_URL}/date-range-new-user-count?start_date=${start}&end_date=${end}`, {
            headers : {
                'DOMAIN-TOKEN' : domainId
            }
        })
        const result = res.data.result;
        const countMap = {}
        result.forEach((item) => {
            const dateStr = formatDate(item.created_date);
            countMap[dateStr] = item.count
        })

        const fullDateList = getAllDatesInRange(start, end)
        const labels = fullDateList.map((date) => formatDate(date));
        const values = fullDateList.map((date) => {
            const key = formatDate(date);
            return countMap[key] || 0
        })
        return {
            labels, 
            datasets : [
                {
                    label : "Total",
                    color : "teal",
                    data   : values,
                }
            ]
        }
    }
    catch(error){
        console.error("failed to fetch chart data:", error)
        return {
            labels : [],
            datasets : []
        }
    }
}

export default GradientLineChartData3;






































